"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OnlineIcon;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } // Generated by build-icons
// Do not edit by hand!
// @hash 2fff379fc72f50b0d4a59ed957b4ff5bcf38322a
const svgElement = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M18.5 18h-5a.5.5 0 0 1 0-1h5c2.481 0 4.5-2.019 4.5-4.5S20.981 8 18.5 8c-.268.004-.538-.171-.573-.422C17.474 4.398 14.711 2 11.5 2A6.508 6.508 0 0 0 5 8.5c0 .28.024.578.076.938a.5.5 0 0 1-.12.402c-.098.109-.24.147-.384.169a.932.932 0 0 1-.105-.01C2.57 10 1 11.57 1 13.5S2.57 17 4.5 17h5a.5.5 0 0 1 0 1h-5A4.505 4.505 0 0 1 0 13.5a4.507 4.507 0 0 1 4.022-4.475A6.391 6.391 0 0 1 4 8.5C4 4.364 7.364 1 11.5 1c3.565 0 6.651 2.561 7.346 6.023C21.758 7.232 24 9.609 24 12.5c0 3.033-2.467 5.5-5.5 5.5z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M11.5 23a.5.5 0 0 1-.5-.5v-7c0-1.93 1.57-3.5 3.5-3.5h.793l-1.146-1.146a.5.5 0 0 1 .707-.707l2 2A.499.499 0 0 1 16.5 13h-2a2.503 2.503 0 0 0-2.5 2.5v7a.5.5 0 0 1-.5.5z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M14.5 15a.5.5 0 0 1-.354-.853l2-2a.5.5 0 0 1 .707.707l-2 2A.498.498 0 0 1 14.5 15z"
}));
function OnlineIcon(props) {
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: "icon icon-online"
  }, props), svgElement);
}